import cn from 'classnames'
import { Icon, IconPrivacyOptionsDefault } from '@mc/design-system'
import { isGeo } from '@mc/geo'
import { useTranslation } from '@mc/i18n'
import { paths } from '@mc/paths'
import Link from 'components/Link'
import MasterclassCertificatesLogo from 'pages/certificates/assets/MasterclassCertificatesWhite.svg'
import { TrackClick } from 'pages/certificates/tracking'
import { getFooterLinks } from './constants'

export function Footer({
  className,
  isLoggedIn,
}: {
  className?: string
  isLoggedIn: boolean
}) {
  const copyrightInfo = `\u00A9 ${new Date().getFullYear()} MasterClass`
  const { t } = useTranslation('@mc/certificates')

  return (
    <footer
      className={cn(
        'p-7 bg-c-base-1300 text-c-text-light flex flex-col md:gap-8 gap-10',
        className,
      )}
    >
      <div className='flex md:flex-row flex-col md:gap-10 gap-7'>
        {getFooterLinks(isLoggedIn).map((linkGroup) => (
          <div key={linkGroup.header} className='flex flex-col gap-5'>
            <p className='c-heading-6 text-c-text-tint-1'>
              {t(linkGroup.header)}
            </p>
            {linkGroup.links.map((link) => {
              if (link.geoUS && !isGeo('US')) return null
              return (
                <TrackClick
                  key={link.label}
                  event='certificateNavigationClicked'
                  product='certificates'
                  level='primary'
                  location='footer'
                  href={link.href}
                >
                  <Link
                    href={link.href}
                    className='mc-text--bare-link'
                    passHref={!link.newTab}
                    newTab={link.newTab}
                    isBasic={link.newTab}
                  >
                    {t(link.label)}
                    {link.showPrivacyIcon && (
                      <IconPrivacyOptionsDefault
                        size='lg'
                        className='overflow-visible ml-1'
                        width='30'
                        height='15'
                        viewBox='0 0 30 15'
                      />
                    )}
                  </Link>
                </TrackClick>
              )
            })}
          </div>
        ))}
      </div>

      <div className='flex flex-col md:flex-row w-full md:justify-between md:items-center items-start gap-6'>
        <Link href={paths.certificates} passHref>
          <MasterclassCertificatesLogo className='w-[216px] h-[59px]' />
        </Link>
        <div className='flex flex-row md:items-center text-c-text-light'>
          <p className='mr-4'>{copyrightInfo}</p>
          <p className='flex items-center'>
            <Icon className='mc-icon--3' kind='locked' />
            <span>{t('marketingPages.hub.footer.secured')}</span>
          </p>
        </div>
      </div>
    </footer>
  )
}
